import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeWithCross = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 15,
	viewBox: "0 0 25 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M24.005 7.29C21.95 2.87 17.26 0 12.05 0C6.84 0 2.15 2.87 0.095 7.29L0 7.5L0.095 7.71C2.15 12.13 6.84 15 12.05 15C17.26 15 21.95 12.15 24.005 7.73L24.1 7.5L24.005 7.29ZM12.05 14C7.315 14 3.05 11.465 1.105 7.5C3.05 3.555 7.315 1 12.05 1C16.785 1 21.05 3.535 22.995 7.5C21.05 11.445 16.785 14 12.05 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0505 3.30518C11.2208 3.30518 10.4097 3.55121 9.71985 4.01216C9.02999 4.47311 8.49231 5.12828 8.1748 5.89482C7.85729 6.66135 7.77421 7.50483 7.93608 8.31858C8.09794 9.13233 8.49748 9.87981 9.08416 10.4665C9.67084 11.0532 10.4183 11.4527 11.2321 11.6146C12.0458 11.7764 12.8893 11.6934 13.6558 11.3759C14.4224 11.0583 15.0775 10.5207 15.5385 9.83079C15.9994 9.14093 16.2455 8.32987 16.2455 7.50018C16.2455 6.38759 15.8035 5.32058 15.0168 4.53386C14.2301 3.74715 13.1631 3.30518 12.0505 3.30518V3.30518ZM12.0505 10.6952C11.4186 10.6952 10.8008 10.5078 10.2754 10.1567C9.75001 9.80565 9.3405 9.30666 9.09867 8.72285C8.85685 8.13904 8.79358 7.49663 8.91686 6.87686C9.04014 6.25709 9.34444 5.6878 9.79126 5.24097C10.2381 4.79414 10.8074 4.48985 11.4272 4.36657C12.0469 4.24329 12.6893 4.30656 13.2731 4.54838C13.857 4.7902 14.3559 5.19971 14.707 5.72513C15.0581 6.25054 15.2455 6.86826 15.2455 7.50018C15.2441 8.34714 14.9071 9.15903 14.3082 9.75792C13.7093 10.3568 12.8974 10.6939 12.0505 10.6952V10.6952Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "eye-cross",
			d: "M0.740234 14.573L23.7402 0.572998",
			stroke: "currentColor"
		})
	]
});
export default SvgEyeWithCross;
